'use strict';

namespace Dashboard {

    type INgModelController = angular.INgModelController;

    interface BagOption {
        Description: string;
        OptionId: string;
        UnitAmount: number;
        UnitWeightKg: number;
    }

    class BaggageOptions {
        private flightBaggageTotal : number;
        private bagOptions: BagOption[];
        private maxBagsSelectable : number;
        private bagsTeaserCost : number;
        private holdBaggageWeight : number;
        private bagsSelected : number; // number of bags selected
        private selectedBagOptions;
        private loading : boolean = true;

        constructor(
            private $scope
        ) {
            const bagOptionsWatch = this.$scope.$watch('cm.bagOptions', val => {
                if (val) {
                    this.maxBagsSelectable = this.bagOptions && this.bagOptions.length || 0;
                    let bag = _.minBy(this.bagOptions, 'UnitAmount');
                    if (bag) {
                        this.bagsTeaserCost = bag.UnitAmount / 2;
                        this.holdBaggageWeight = bag.UnitWeightKg || TRPCONFIG.Domain.DashboardHoldBaggageWeight;
                    }
                    bagOptionsWatch();
                    this.loading = false;
                }
            }, true);
        }

        updateBaggageOptions() {
            const selectedBagOptionsRaw : BagOption[] = this.bagOptions.slice(0, this.bagsSelected);
            this.flightBaggageTotal = _(selectedBagOptionsRaw).sumBy('UnitAmount');
            this.selectedBagOptions = (selectedBagOptionsRaw.map(so => ({OptionId: so.OptionId, ChosenQuantity: 1})));
        }
    }

    angular
        .module('core')
        .component('baggageOptions', {
            bindings: {
                bagOptions: '=',
                handBaggageInformation: '=',
                flightBaggageTotal: '=',
                selectedBagOptions: '='
            },
            controller: BaggageOptions,
            controllerAs: 'cm',
            templateUrl: 'partials/home/baggageoptions'
        }
    );
}
